var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordButtonSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Record",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.466,
    height: 14.466,
    viewBox: "0 0 14.466 14.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29298",
    "data-name": "\\u30D1\\u30B9 29298",
    d: "M11.018,15.037A4.018,4.018,0,1,0,7,11.018,4.018,4.018,0,0,0,11.018,15.037Z",
    transform: "translate(-3.785 -3.785)",
    fill: "#150e04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_29299",
    "data-name": "\\u30D1\\u30B9 29299",
    d: "M17.466,10.233A7.233,7.233,0,1,1,10.233,3a7.233,7.233,0,0,1,7.233,7.233Zm-1.607,0a5.626,5.626,0,1,1-5.626-5.626,5.626,5.626,0,0,1,5.626,5.626Z",
    transform: "translate(-3 -3)",
    fill: "#150e04",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordButtonSmall);
export default __webpack_public_path__ + "static/media/recordButtonSmall.21cc51d3640f579b1a6d11c89317156e.svg";
export { ForwardRef as ReactComponent };